import { API_PRIVATE_HOST, API_PUBLIC_HOST } from "@/_constant";
import api from "./request";

export function fetchListingPlans(payload) {
    return new Promise(async (resolve, reject) => {
        try {
            const res = await api.post(`${API_PUBLIC_HOST}/plan/listPlansForSeller`, payload);
            resolve(res);
        } catch (err) {
            reject(err);
        }
    });
}

export function saveListingAddonPlan(listingId, additionalPlanId = "", withGreatDealBanner = false, isTopProperty = false, isExclusive = false) {
    return new Promise(async (resolve, reject) => {
        try {
            let greatDeal = false;
            let topProp = false;
            let exclusive = false;

            if (typeof withGreatDealBanner === "object" && withGreatDealBanner !== null) {
                greatDeal = Boolean(withGreatDealBanner.withGreatDealBanner);
                topProp = Boolean(withGreatDealBanner.isTopProperty);
                exclusive = Boolean(withGreatDealBanner.isExclusive);
            } else {
                greatDeal = Boolean(withGreatDealBanner);
                topProp = Boolean(isTopProperty);
                exclusive = Boolean(isExclusive);
            }

            const URL = `${API_PRIVATE_HOST}/listing/addAdditionalPlanForListing?listId=${listingId}&additionalPlanId=${additionalPlanId}&withGreatDealBanner=${greatDeal}&isTopProperty=${topProp}&isExclusive=${exclusive}`;
            const res = await api.get(URL);
            resolve(res);
        } catch (err) {
            reject(err);
        }
    })
}


export function listUserAccessPackageByCategory(categoryId) {
    return new Promise(async (resolve, reject) => {
        try {
            const URL = `${API_PRIVATE_HOST}/plan/listUserAccessPackageByCategory?categoryId=${categoryId}&listChildren=false`;
            const res = await api.get(URL);
            resolve(res);
        } catch (err) {
            reject(err);
        }
    })
}

export function removeListingAddonPlan(listingId) {
    return new Promise(async (resolve, reject) => {
        try {
            const URL = `${API_PRIVATE_HOST}/listing/removeAdditionalPlanForListing?listId=${listingId}`
            const res = await api.get(URL);
            resolve(res);
        } catch (err) {
            reject(err);
        }
    })
}

export function fetchAvailablePlans(requestPayload){
    const URL = `${API_PUBLIC_HOST}/plan/listAvailablePlans`;
    return api.post(URL, requestPayload);
}

export function fetchUserPlans(userId) {
    return new Promise(async (resolve, reject) => {
        try {
            let url = `${API_PRIVATE_HOST}/userPlan/listUserPlans?`;
            if (userId) {
                url += `userId=${encodeURIComponent(userId)}`
            }
            const res = await api.get(url);
            resolve(res);
        } catch (err) {
            reject(err);
        }
    });
}